import React from 'react';
import {Grid, Segment, Label} from 'semantic-ui-react';
import _ from "lodash";
import VSDMacro from "../../Macros/VSDMacro";
import {isAuthorized} from '../../../lib/authorization';
import {useSelector} from "react-redux";

const VSDColumn = ({ index, column, data, option, tagid }) => {

    const ppid = useSelector(state => state.header.ppid);
    const user = useSelector(state => state.nav.user);
    const electronApp = useSelector(state => state.nav.electronApp);

    const convertValue =(value) => {
        if(value === 0){
            return 'LOCAL CONTROL'
        }
        else{
            return 'REMOTE CONTROL' 
        }
    }

    const groupBySubDisplay = (items) => {
        return items.reduce((acc, item) => {
            const subdisplay = item.hmi_controlloop_subdisplay;

            if(!acc[subdisplay]){
                acc[subdisplay] = [];
            }

            acc[subdisplay].push(item);
            return acc;
        }, {});
    };

    const displayFaultData = (items) => {
        const grouped = groupBySubDisplay(items);

        return Object.keys(grouped).map((subdisplay, idx) => (
            <div key={idx} style={{marginTop: idx === 0 ? '0' : '10px'}}>
                <h3 style={styles.subdisplayHeader}>
                    {subdisplay}
                </h3>
                <Grid style={{margin : 0}}>
                    {grouped[subdisplay].map(r => (
                        <Grid.Row key={r.id} style={styles.bitRow}>
                            <Grid.Column width='13' style={styles.bitName}>
                                {r.tag_display_name}
                            </Grid.Column>
                            <Grid.Column width='3' textAlign='right' >
                                <Label circular horizontal empty size='large' color={getColor(data[r.id])}/>
                            </Grid.Column>
                        </Grid.Row>
                    ))}
                </Grid>
            </div>
        ));
    };

    const getColor = (parm) => {
        if(parm === 1){
            return 'red';
        }else{
            return 'green';
        }
    }

    const gridColumn = _.times((1), (i) => (
        Object.keys(column).map(i => (
            <Segment inverted>
                <Grid columns='2' stackable padded style={styles.grid}>
                    <p style={styles.header}>{column[i][0].tag_display_subgroup}</p>
                    {column[i][0].tag_display_subgroup?.includes('FAULT')?
                        displayFaultData(column[i])
                        :
                        column[i].map(r =>
                            <Grid.Row colums = {6} key={r.id} style={styles.row}>
                                {r.tag_display_name === 'RESETFAULTS' && r.display_id === 12 ?
                                    <div style = {{marginTop: '10px'}}>
                                        <VSDMacro
                                            title = {r.tag_display_name}
                                            description = {'Reset ' + r.name + '?'}
                                            tagid ={r.id}
                                            channel = {'Reset VSD'}/>
                                    </div>
                                    :
                                    <>
                                        <Grid.Column width='8' style={styles.name}>{r.tag_display_name} </Grid.Column>
                                    </>
                                }
                                {r.tag_display_name === 'Local' || r.tag_display_name === 'LOCAL' ?
                                    <Grid.Column width='8'
                                                 style={{color: data[r.id] === 0? 'red' : 'green'}}>{convertValue(data[r.id])}</Grid.Column>
                                    :
                                    r.tag_display_name === 'RESETFAULTS' ?
                                        ''
                                        :
                                        <>
                                            <Grid.Column width='4' style={styles.name}>{data[r.id]} </Grid.Column>
                                            <Grid.Column width='4' style={styles.unit}>{r.unit ==='NA' ? '' : r.unit} </Grid.Column>
                                        </>
                                }
                            </Grid.Row>
                        )}
                    { option === 2 ? // PAFC
                        <div style = {{marginTop: '10px'}}>
                            {(electronApp || isAuthorized(user.hmi_role, 'A')) &&
                            <VSDMacro
                                title = {column[i][1].tag_display_name}
                                description = {'Reset' + column[i][1].tag_display_subgroup + '?'}
                                tagid ={column[i][1].id}
                                channel = {'Reset VSD'}/>
                            }
                        </div>
                        : ''
                    }

                </Grid>
            </Segment>
        ))
    ))


    return (
        <Grid.Column key={index} style={{ maxWidth: '2000px', padding: '10' }}>
            {gridColumn}
        </Grid.Column>
    );
};

const styles = {
    grid: {
        margin: '0',
        padding: '0',
        marginBottom: '0',
        maxWidth: '340px'
    },
    row: {
        padding: '2px 0'
    },
    name: {
        color: 'yellow',
        fontSize: '18px',
        fontWeight: 'bold'
    },
    header: {
        marginBottom: '10px',
        marginLeft: '90px',
        fontWeight: 'bold',
        fontSize:'20px'
    },
    // update 240207 by sumin, to display unit 
    unit : {
        color : 'white',
        fontSize : '18px'
    },
    faultGroup : {
        color : 'yellow',
        fontSize : '18px'
    },
    subdisplayHeader : {
        marginBottom : '10px',
        fontWeight : 'bold',
        fontSize : '18px',
        marginTop : '20px'

    },
    bitName: {
        color : 'yellow',
        fontXize : '18px',
        fontWeight: 'bold',
        display: 'inline-block'
    },
    bitRow: {
        padding: '2px 0px',
    },

};

export default React.memo(VSDColumn);
